<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Civil Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Achievements'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="9"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Achievements</div>
          <div>
            <TabView ref="tabview">
              <TabPanel header="Students">
                <table class="achievements">
                  <thead>
                  <tr>
                    <th scope="col" class="">
                      #
                    </th>
                    <th scope="col" class="">
                      Name of Student
                    </th>
                    <th scope="col" class="">
                      Year
                    </th>
                    <th scope="col" class="">
                      Achievement
                    </th>
                    <th scope="col" class="relative px-6 py-3">
                      <span class="sr-only"></span>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="">
                    <td class="">
                      1
                    </td>
                    <td class="">
                      Sliver
                    </td>
                    <td class="">
                      Laptop
                    </td>
                    <td class="">
                      $2999
                    </td>
                    <td class="action">
                      <a href="#" class="text-blue-600 hover:text-blue-900"><i class="fas fa-link"></i></a>
                    </td>
                  </tr>

                  </tbody>
                </table>
              </TabPanel>
              <TabPanel header="Faculty">
                <Accordion>
                  <AccordionTab header="Faculty I">
                    <table class="achievements">
                      <thead>
                      <tr>
                        <th scope="col" class="">
                          #
                        </th>
                        <th scope="col" class="">
                          Year
                        </th>
                        <th scope="col" class="">
                          Achievement
                        </th>
                        <th scope="col" class="relative px-6 py-3">
                          <span class="sr-only"></span>
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr class="">
                        <td class="">
                          1
                        </td>
                        <td class="">
                          Laptop
                        </td>
                        <td class="">
                          $2999
                        </td>
                        <td class="action">
                          <a href="#" class="text-blue-600 hover:text-blue-900"><i class="fas fa-link"></i></a>
                        </td>
                      </tr>

                      </tbody>
                    </table>
                  </AccordionTab>
                  <AccordionTab header="Faculty II">
                    Content
                  </AccordionTab>
                  <AccordionTab header="Faculty III">
                    Content
                  </AccordionTab>
                </Accordion>
              </TabPanel>
            </TabView>
          </div>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/civil/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';


export default {
  name: "Achievements",
  components: {
    KeyRecruiters,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    TabView,
    TabPanel,
    Accordion,
    AccordionTab
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {div: null}
  }
}
</script>
<style lang="scss" scoped/>
